import Vue from 'vue'
import Vuex from 'vuex'
import '../_axios'
import worker from '../api/worker'
import { getAllAppMenus } from '../api/manage'
import { filterAsyncRouter } from '../utils/appUtil'
import router from '../_router'
import { saveDefaultProjectId } from '../api/project'
import { getButtonPermissions } from '../api/user'
import { list } from '../api/logomanage'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    projectList: null, // 项目列表
    selectProject: null, // 所选择的项目
    isGetApp: true, // 判断刷新状态
    dangerSearch: null, // 危险源巡检查询条件
    photoSearch: null, // 随手拍查询条件
    checkSearch: null, // 安防办督察条件
    areaSearch: null, // 区域巡检查询条件
    disinfectSearch: null, // 消杀查询条件

    projectInfoTab: null, // 项目详情页面跳转返回tab记录
    type: null, // 入口状态 1:单入口 2:多入口
    currentEnter: null, // 当前入口 1:工地 2:总部
    levels: [], // 登陆级别
    level: 1, // 登陆级别,
    perms: [],
    loginlogo: '',
    maplogo: ''
  },
  mutations: {
    SET_TYPE(arg_state, arg) {
      window.sessionStorage.setItem('loginType', arg)
      arg_state.type = arg
    },
    SET_CURRENT_ENTER(state, arg) {
      window.sessionStorage.setItem('currentEnter', arg)
      state.currentEnter = arg
    },
    async setGetApp(state, is) {
      state.isGetApp = is
    },
    async setAppMenus(state) {
      console.log('加载路由')
    },
    setProjectList(arg_state, arg) {
      arg_state.projectList = arg
    },
    async setSelectProject(arg_state, arg) {
      window.sessionStorage.setItem('selectProject', JSON.stringify(arg))
      arg_state.selectProject = arg
      await saveDefaultProjectId(arg.projectId)
      const res = await getAllAppMenus({ projectId: arg.projectId })
      const routes = filterAsyncRouter(res.data.data)
      router.addRoutes(routes)
      arg_state.isGetApp = false
    },

    setDangerSearch(arg_state, arg) {
      arg_state.dangerSearch = arg
    },
    setPhotoSearch(arg_state, arg) {
      arg_state.photoSearch = arg
    },
    setCheckSearch(arg_state, arg) {
      arg_state.checkSearch = arg
    },
    setAreaSearch(arg_state, arg) {
      arg_state.areaSearch = arg
    },
    setDisinfectSearch(arg_state, arg) {
      arg_state.disinfectSearch = arg
    },

    setProjectInfoTab(arg_state, arg) {
      arg_state.projectInfoTab = arg
    },
    setPerms(state, val) {
      state.perms = val
    },
    setLogo(state, param) {
      switch (param.type) {
        case '4':
          state.loginlogo = param.url
          break
        case '5':
          state.maplogo = param.url
          break
      }
    }
  },
  getters: {
    GET_TYPE(arg_state) {
      return arg_state.type == null ? window.sessionStorage.getItem('loginType') : arg_state.type
    },
    GET_CURRENT_ENTER(arg_state) {
      return arg_state.currentEnter == null ? window.sessionStorage.getItem('currentEnter') : arg_state.currentEnter
    },
    getProjectList(arg_state) {
      return arg_state.projectList
    },
    getSelectProject(arg_state) {
      return arg_state.selectProject
    },
    getDangerSearch(arg_state) {
      return arg_state.dangerSearch
    },
    getPhotoSearch(arg_state) {
      return arg_state.photoSearch
    },
    getCheckSearch(arg_state) {
      return arg_state.checkSearch
    },
    getAreaSearch(arg_state) {
      return arg_state.areaSearch
    },
    getDisinfectSearch(arg_state, arg) {
      return arg_state.disinfectSearch
    },
    getProjectInfoTab(arg_state) {
      return arg_state.projectInfoTab
    },
    perms: state => state.perms
  },
  actions: {
    async actionProjectList(arg_store) {
      const res = await worker.projectlist()
      if (res.data.code === 0) {
        arg_store.commit('setProjectList', res.data.data)
        if (res.data.data.length !== 0) {
          let selPro = res.data.data.filter(item =>
            item.defaultProjectId === item.projectId
          )
          if (selPro.length === 0) {
            selPro = res.data.data
          }
          const obj = JSON.parse(window.sessionStorage.getItem('selectProject'))
          obj ? arg_store.commit('setSelectProject', obj) : arg_store.commit('setSelectProject', selPro[0])
        }
      }
    },
    setLogoAction({ commit }) {
      list().then(res => {
        if (res.data.code === 0) {
          res.data.data.forEach((item) => {
            commit('setLogo', item)
          })
        }
      })
    },

    getButtonPermissions({ state, commit }, projectId) {
      return new Promise(resolve => {
        getButtonPermissions(projectId).then(res => {
          if (res.data.code === 0) {
            commit('setPerms', res.data.data)
          }
        })
      })
    }

  }
})

export default store



// WEBPACK FOOTER //
// ./src/_vuex/index.js